import React from 'react';
import { motion } from 'framer-motion';

const easeLuxury = [0.22, 1, 0.36, 1];

const BRANDS = [
  { name: 'DYO', src: '/logos/dyo.gif' },
  { name: 'BASF', src: '/logos/basf.png' },
  { name: 'Sintaş', src: '/logos/sintas.png' },
];

export default function Brands() {
  return (
    <section className="bg-bg-primary border-y border-border-soft py-16 sm:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.7, ease: easeLuxury }}
          className="space-y-3 mb-10 sm:mb-14"
        >
          <p className="text-accent-gold font-semibold tracking-[0.3em] uppercase text-sm">
            Güvenilir Marka Partnerleri
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tightest">
            Çalıştığımız Markalar
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-100px' }}
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
          className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6"
        >
          {BRANDS.map((brand) => (
            <motion.div
              key={brand.name}
              variants={{ hidden: { opacity: 0, y: 32 }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: easeLuxury } } }}
              className="group bg-white rounded-2xl p-6 sm:p-10 flex items-center justify-center border border-border-soft hover:border-accent-gold transition-colors duration-500 hover:-translate-y-1"
              style={{ transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)' }}
            >
              <img
                src={brand.src}
                alt={brand.name}
                className="h-12 sm:h-16 w-auto object-contain transition-transform duration-700 ease-luxury group-hover:scale-105"
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
